import { apiFetch } from "../../http";
export async function deleteTravelFile(params) {
    const { baseUrl, travelPlanId, fileId, token, csrfToken } = params;
    return apiFetch(`/travel/api/delete_travel_file/${travelPlanId}/${fileId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined,
        credentials: "include"
    });
}
/** Upload receipts return the saved files as an array, including idempotent replays. */
export function uploadedTravelFileIds(value) {
    const payload = value && typeof value === 'object' ? value : {};
    const files = Array.isArray(value) ? value : Array.isArray(payload.files) ? payload.files : Array.isArray(payload.created_files) ? payload.created_files : [];
    return [...new Set(files.flatMap(file => {
            var _a, _b;
            const data = file && typeof file === 'object' ? file : {};
            const id = (_b = (_a = data.travel_file_id) !== null && _a !== void 0 ? _a : data.file_id) !== null && _b !== void 0 ? _b : data.id;
            return id === null || id === undefined || String(id).trim() === '' ? [] : [String(id)];
        }))];
}
export async function uploadTravelFiles(params) {
    const { baseUrl, travelPlanId, files, names, itemTravelId, token, csrfToken } = params;
    const formData = new FormData();
    files.forEach((file, index) => {
        if (file && typeof file === "object" && "uri" in file) {
            const nativeFile = file;
            formData.append("files", {
                uri: nativeFile.uri,
                name: String(nativeFile.name || `trackme-file-${index + 1}.bin`),
                type: String(nativeFile.type || "application/octet-stream"),
            });
            return;
        }
        formData.append("files", file);
    });
    names.forEach((name) => formData.append("names", name));
    if (params.operationId)
        formData.append('operation_id', params.operationId);
    formData.append("item_travel_id", itemTravelId == null ? "" : String(itemTravelId));
    return apiFetch(`/travel/api/upload_travel_files/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined,
        body: formData,
        credentials: "include"
    });
}
export async function getTravelItemsFilesSummary(params) {
    const { baseUrl, travelPlanId, token } = params;
    return apiFetch(`/travel/api/get_travel_items_files_summary/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include"
    });
}
